import { localesSlice } from './locales';
import { scrollNumSlice } from './scrollNum';
import { recReSizeSlice } from './recReSize';
import { viewrSlice } from './viewr';

export const reduces = {
    localesSlice,
    scrollNumSlice,
    recReSizeSlice,
    viewrSlice,
};

